import React from 'react';
import PropTypes from 'prop-types';
import SearchField from '../../shared/components/SearchField';

export default function SearchBar({ value, onChange, placeholder = 'Search assets...' }) {
  return (
    <SearchField
      id="user-asset-search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="mb-3"
      aria-label="Search assets"
    />
  );
}

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
